<template>
	<div>

		<div class="alert alert-success">
			尊敬的管理员，欢迎来到{{$store.state.appName}}后台管理系统。
		</div>

	</div>


</template>
<script>
	import NbEditorDemo from "../wheel/NbEditorDemo.vue";
	export default {

		data () {
			return {
				show: false,
				hasData: false
			}
		},
		components: {},
		methods: {
			addRouter(){
				//获取某个路由。
				let currentRouter = this.$router;
				let currentRoute = this.$route;
				this.$router.addRoutes([
					{
						path: "/good",
						name: "customNbEditorDemo",
						component: NbEditorDemo
					}
				]);


			}
		}
	}
</script>



// WEBPACK FOOTER //
// Index.vue?3badad5c